import React from 'react'
import { withStyles } from '@material-ui/core';
import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';
import './css/chatPlaceholder.css'
import { useTranslation } from 'react-i18next';

const styles = theme => ({

    header: {
        margin: 0
    },
    button: {
        textTransform: 'unset',
        marginTop: '10px'
    },
    link: { "fontFamily": "\"Rubik\", Helvetica, Arial, serif", "fontWeight": "400", "fontStyle": "normal", "fontSize": "14.0px", "color": "rgba(107, 19, 246, 1.0)", "textAlign": "center", "letterSpacing": "0.25px", "lineHeight": "20.0px" }

});

export default withStyles(styles)((props) => {
    const { classes } = props;
    const { t, i18n } = useTranslation('feedWidgets');
    return <Grid container spacing={16} justify={"center"} className={classes.header} spacing={16}>

        <Grid item xs={6}>
            <div data-intrcm-id="LibraryPlaceholder_3kvqns1l">
                <input id="anPageName" name="page" type="hidden" defaultValue="chatplaceholder" />
                <div data-intrcm-id="LibraryPlaceholder_5451fell" className="chatplaceholder anima-word-break ">
                    <div data-intrcm-id="LibraryPlaceholder_8glo8v4l" style={{ height: '100%', position: 'relative', margin: 'auto' }}>
                        <div data-intrcm-id="LibraryPlaceholder_ujz8md6z" className="chatplaceholder1">
                            <div data-intrcm-id="LibraryPlaceholder_cweyec6w" className="rectangle">
                            </div>
                            <img alt="Image" className="illustrationchat" src={"/resources/placeholders/library-illustration.svg"} style={{ "backgroundColor": "rgba(255,255,255,0.0)", "top": "130px", "height": "317px", "width": "420px", "position": "absolute", "margin": "0", "WebkitTransform": "rotate(0deg)", "MsTransform": "rotate(0deg)", "transform": "rotate(0deg)", "opacity": "1.0" }} />
                            <div data-intrcm-id="LibraryPlaceholder_cfmqab0b" className="tuqqischatakatu anima-valign-text-middle" style={{ top: 460 }}>
                                <span><span className="span1">{t('The system automatically manages all the knowledge of your organization and organizes it by topics, categories, and groups')}.
                                <br />
                                    <br />
                                    {t('The library will be available when you will have more than 30 items')}.
                                </span>
                                    <br />
                                    <span>
                                        <b><a href={"https://intercom.help/tuqqi/en/articles/3918096-introduction-to-your-organizational-library"} target="_blank" className={classes.link}>{t('Learn more')}</a></b>{t('about the library')}.</span>
                                </span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </Grid>
    </Grid>
})